import React, {Component} from 'react';
import { connect } from 'react-redux';
import {withStyles} from "@material-ui/core";
import {bindActionCreators} from "redux";
import {actionCreators as offerActions} from "../../store/Offer";
import Paper from "@material-ui/core/Paper";
import AppBar from "@material-ui/core/AppBar/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Typography from "@material-ui/core/Typography";
import history from "../../helpers/historyHelper";
import DeleteIcon from '@material-ui/icons/Delete';

import Moment from "react-moment";

const styles = theme => ({
    paper: {
        overflow: 'hidden',
    },
    searchBar: {
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    },
    searchInput: {
        fontSize: theme.typography.fontSize,
    },
    block: {
        display: 'block',
    },
    newOffer: {
        marginRight: theme.spacing(1),
    },
    contentWrapper: {
        margin: '40px 26px',
    },
    itemRow: {
        cursor: "pointer",
        "&:hover": {
            background: "#efefef",
            textDecoration: "underline"
        }
    }
});

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    filesChanged = (items) => { 
        console.log(items);
    };
    
    handleCreateOfferSuccess = (offerId) => {
        history.push(`/offer/${offerId}`);
        console.log(offerId);
    };
    
    handleCreateOffer = () => {
        this.props.offerActions.createOffer(this.handleCreateOfferSuccess);
    };
    
    deleteDraft = (e, offerId) => {
        e.stopPropagation();
        if(!window.confirm("Er du sikker?")) return;
        this.props.offerActions.deleteDraft(offerId, this.reloadOffers);
    };
    
    reloadOffers = () => {
        this.props.offerActions.getOffers();
    };
    
    render() {
        const {classes} = this.props;
        return (
            <div>
                <Paper style={{padding: 20, paddingTop: 5}}>
                <h1>Velkommen til Ekstrautstyrsportalen</h1>
                <div>
                    <Typography variant="body1" component="h2">Det blir mer og mer forskjellige typer montert utstyr i, og på merd i sjøbasert havbruk. Økende krav til dokumentasjon på utstyrets egnethet, og felles forståelse for riktig utforming og plassering av slikt utstyr har ført til et behov for en standard til bruk i vurdering og godkjenning av utstyr.</Typography>
                    <br/>
                    <Typography variant="body1" component="h2">Det er viktig at leverandørindustrien har en forståelse for de kreftene hovedkomponentene blir utsatte for, og hvordan eget utstyr oppleves i samspill med dette. Samtidig skal fiskevelferd og sikkerheten til driftspersonell ivaretas.</Typography>
                    <br/>
                    <Typography variant="body1" component="h2">Hensikten med denne standarden er derfor å veilede leverandører og LSG til å lettere tilpasse utstyr til bruk ved og i hovedkomponenter ved sjøbasert havbruk. Målet er å minimere sannsynligheten for skade på utstyr, miljø og personell.</Typography>
                    <br/>
                    <Typography variant="body1" component="h2">Det er krav om at utstyr som skal monteres på, eller i, en hovedkomponent skal oppfylle krav som stilles i NYTEK-forskriften, NS9415 og andre ordninger som vil regulere utforming og funksjon til det aktuelle utstyret.</Typography>
                </div>
                </Paper>
                <br/>
                <Paper className={classes.paper}>
                    <AppBar className={classes.searchBar} position="static" color="default" elevation={0}>
                        <Toolbar>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs>
                                    <h3>Produktliste</h3>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" color="primary" className={classes.newOffer} onClick={this.handleCreateOffer} >
                                        Legg til produkt
                                    </Button>
                                </Grid>
                            </Grid>
                        </Toolbar>
                    </AppBar>
                    <div className={classes.contentWrapper}>
                        {this.props.offer.offers.length !== 0 &&
                        <Table className={classes.table} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell algin="left">Ref.Nr</TableCell>
                                    <TableCell align="left">Produkt</TableCell>
                                    <TableCell align="left">Status</TableCell>
                                    <TableCell align="left">Organisasjon</TableCell>
                                    <TableCell align="left">Registrert av</TableCell>
                                    <TableCell align="left">Registrert dato</TableCell>
                                    <TableCell align="left"/>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.props.offer.offers.map(row => (
                                    <TableRow className={ classes.itemRow } key={row.offerId} onClick={() => {history.push(`/offer/${row.offerId}`)}}>
                                        <TableCell align="left">{row.offerId}</TableCell>
                                        <TableCell align="left">{row.title}</TableCell>
                                        <TableCell align="left">{row.offerStatus.status}</TableCell>
                                        <TableCell align="left">{row.organization.name}</TableCell>
                                        <TableCell align="left">{row.registeredByUser.fullname}</TableCell>
                                        <TableCell align="left"><Moment>{row.registeredDate}</Moment></TableCell>
                                        <TableCell aling="right">
                                            {row.offerStatusId === 1 &&
                                                <IconButton aria-label="delete" onClick={(e) => this.deleteDraft(e, row.offerId)}>
                                                    <DeleteIcon/>
                                                </IconButton>
                                            }
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        }

                        {this.props.offer.offers.length === 0 &&
                        <Typography color="textSecondary" align="center">
                            Ingen tilbud tilgjengelig
                        </Typography>
                        }
                    </div>
                </Paper>
            </div>
        )
    };

    componentDidMount() {
        this.props.offerActions.getOffers();
    }
    componentWillUnmount() {
        console.log(123)
    }
}

function mapDispatchToProps(dispatch) {
    return {
        offerActions: bindActionCreators(offerActions, dispatch),
    }
}

function mapStateToProps(state) {
    return {
        offer: state.offer,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Home));
